// src/pages/ServiceExpenseLedger/ServiceExpenseLedgerThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getServiceExpenseLedgerApi } from "../../../apiservice/reports";
import { getAccountBySeachApi } from "../../../apiservice/setting";

export const fetchServiceExpenseLedger = createAsyncThunk(
  "serviceExpenseLedger/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const payload = {
        accId: filters?.accId || null,
        dateFrom: filters?.fromDate || null,
        dateTo: filters?.toDate || null,
      };
      const res = await getServiceExpenseLedgerApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchServiceExpenseAccountsBySearch = createAsyncThunk(
  "serviceExpenseLedger/fetchAccountsBySearch",
  async (search, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
        query: search.trim(),
        search: true,
        multiType: ["service_expense_account"],
      });
      return (res.data || []).map((c) => ({
        sale_id: c.acc_id,
        display_text: c.acc_name,
      }));
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
